import { render, staticRenderFns } from "./TabComposizioneOre.vue?vue&type=template&id=51e125dd&"
import script from "./TabComposizioneOre.vue?vue&type=script&lang=js&"
export * from "./TabComposizioneOre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports